import { render, staticRenderFns } from "./ServiceOffer.vue?vue&type=template&id=22fe0bbf&scoped=true&"
import script from "./ServiceOffer.vue?vue&type=script&lang=js&"
export * from "./ServiceOffer.vue?vue&type=script&lang=js&"
import style0 from "./ServiceOffer.vue?vue&type=style&index=0&id=22fe0bbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe0bbf",
  null
  
)

export default component.exports